'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$4 = require('./styles-38df6401.js');

var SelectButton = function (_a) {
    var text = _a.text, name = _a.name, value = _a.value, checked = _a.checked, variant = _a.variant, _b = _a.sizeOption, sizeOption = _b === void 0 ? 'sm' : _b, testId = _a.testId, onChange = _a.onChange;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(styles$4.FormInput, { variant: variant, sizeOption: sizeOption, type: "radio", id: value, name: name, value: value, checked: checked, onChange: onChange }),
        React__default.createElement(styles$4.FormLabel, { className: "select-button-label", htmlFor: value, "data-testid": testId + "-" + value, "data-cy": testId + "-" + value }, text)));
};

exports.SelectButton = SelectButton;
